import { render, staticRenderFns } from "./ChangeEmailModal.vue?vue&type=template&id=ff35c8d2&scoped=true"
import script from "./ChangeEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChangeEmailModal.vue?vue&type=style&index=0&id=ff35c8d2&prod&scoped=true&lang=css"
import style1 from "./ChangeEmailModal.vue?vue&type=style&index=1&id=ff35c8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff35c8d2",
  null
  
)

export default component.exports